// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__rBq8s"};